<template>
  <div class="activity-body">
    <div class="activity-tab">
      <span :class="{ active: activityStatus === '' }" @click="activityStatus = ''"
      >全部</span
      >
      <span :class="{ active: activityStatus === '0' }" @click="activityStatus = '0'"
      >报名中</span
      >
      <span :class="{ active: activityStatus === '1' }" @click="activityStatus = '1'"
      >进行中</span
      >
      <span :class="{ active: activityStatus === '2' }" @click="activityStatus = '2'"
      >已结束</span
      >
    </div>
    <div class="activity-list-body">
      <template v-if="activityList&&activityList.length">
        <div
          class="activity-list"
          v-for="el in activityList"
          :key="el.id"
          @click="activityDetail(el.id)"
        >
          <v-activity-status :activity-status="el.activityStatus" />
          <span>
            <v-img
              :attachment-id="el.coverId"
              :default-img="require('@/assets/img/mediaApp2.png')"
            ></v-img>
          </span>
          <div>
            <p>{{ el.activityName }}</p>
            <span
            >活动时间：{{ el.activityTime | moment("YYYY-MM-DD HH时") }}</span
            >
            <span>活动地点：{{ el.activityPlace }}</span>
            <div>
              <span>{{ el.enrollNumber ? el.enrollNumber : "0" }}人报名</span>
              <div>
                <span><img src="@/assets/img/qyimg.png" /></span>
                <span><img src="@/assets/img/qyimg.png" /></span>
                <span><img src="@/assets/img/qyimg.png" /></span>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div v-else style="width: 100%;padding-top: 50px;">
        <a-empty />
      </div>
    </div>
  </div>
</template>

<script>
import { usermyactivity } from "@/api/activity";
import VImg from "@/components/VImg";
import VActivityStatus from "@/components/VActivityStatus";

export default {
  components: { VActivityStatus, VImg },
  data() {
    return {
      page: {
        size: 20,
        current: 1,
        total: 0
      },
      activityStatus: "",
      activityList: []
    };
  },
  watch: {
    activityStatus: function() {
      this.loadUsermyactivity();
    }
  },
  mounted() {
    this.loadUsermyactivity();
  },
  methods: {
    loadUsermyactivity() {
      const { activityStatus } = this;
      usermyactivity(this.page, {
        activityStatus
      }).then((res) => {
        this.activityList = res.data.records;
      });
    },
    activityDetail(id) {
      this.$router.push({
        path: "/homeActivity/detail",
        query: { id: id }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.activity-body {
  padding: 24px;
  background: #f5f5f5;
  height: 100%;
  overflow-y: auto;

  .activity-tab {
    display: flex;
    margin-bottom: 24px;

    > span {
      width: 96px;
      height: 32px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      border-radius: 2px 0px 0px 2px;
      text-align: center;
      line-height: 30px;
      cursor: pointer;

      &.active {
        color: #1abc9c;
        border-color: #1abc9c;
      }
    }
  }

  .activity-list-body {
    display: flex;
    flex-wrap: wrap;

    .activity-list {
      width: 390px;
      background: #ffffff;
      border-radius: 2px;
      margin-right: 18px;
      margin-bottom: 18px;
      position: relative;
      overflow: hidden;
      transition: all 0.3s;
      cursor: pointer;

      &:nth-child(4n) {
        margin-right: 0;
      }

      &:hover {
        box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.08);
        transform: translateY(-4px);
      }

      > img {
        position: absolute;
        top: 0;
        left: 20px;
      }

      > span {
        display: block;
        height: 220px;

        > img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }

      > div {
        padding: 16px 24px;

        > p {
          font-size: 16px;
          line-height: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-bottom: 16px;
        }

        > span {
          font-size: 12px;
          display: block;
          line-height: 12px;
          color: #8c8c8c;
          margin-bottom: 16px;
        }

        > div {
          display: flex;
          justify-content: space-between;
          align-items: center;

          > span {
            color: #bfbfbf;
            font-size: 12px;
          }

          > div {
            display: flex;

            > span {
              width: 24px;
              height: 24px;
              border-radius: 50%;

              > img {
                width: 100%;
                height: 100%;
                display: block;
              }
            }
          }
        }
      }
    }
  }
}
</style>
